import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer.jsx';
import Navbar from './Navbar.jsx';

export default function AppLayout() {
  const { pathname } = useLocation();
  const isCheckout = pathname === '/checkout';

  return (
    <div className={`app-shell ${isCheckout ? 'checkout-shell-mode' : ''}`}>
      {isCheckout ? null : <Navbar />}
      <main>
        <Outlet />
      </main>
      {isCheckout ? null : <Footer />}
    </div>
  );
}
